import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';

import classes from './Topbar.module.css';
import Logo from '../../Logo/Logo';
// import NavigationItem from '../../Navigation/NavigationItem/NavigationItem';
import Button from '../../UI/Buttons/Button';
// import LoginRegister from '../../../containers/LoginRegister/LoginRegister';
import PopupPanel from '../../../components/UI/PopupPanel/PopupPanel';
import espa_banner from '../../../assets/images/logo_ebdm34_el.jpg';
import * as actions from '../../../store/actions/index';


class Topbar extends Component {

    state={
        mobileMenuOpen:false,
        showInfo:false
    }

    componentDidMount () {
        this.props.onGetUserFromLocalStorage();
    }

    logout() {
        this.props.onLogoutUser();
        this.props.history.push('/login');
    }

    showInfo(){
        this.setState({showInfo:!this.state.showInfo});
    }


    render(){
        return(
            <div className={classes.Topbar}>

                {this.showInfo ? 
                    <PopupPanel 
                        title='ΠΛΗΡΟΦΟΡΙΕΣ'
                        show={this.state.showInfo}
                        clicked={()=>this.showInfo()}           
                    >
                        <p>Σκοπός της διαδικτυακής εφαρμογής Χαρτογραφικά Δεδομένα Πυρκαγιών είναι να προσφέρει βασικές γεωγραφικές πληροφορίες για τις δασικές πυρκαγιές στην Ελλάδα. Τα χαρτογραφικά προιόντα παράχθηκαν κατά την υλοποίηση του ερευνητικού έργου «Ανάπτυξη προηγμένου αλγορίθμου και λογισμικού ανοιχτού κώδικα για την αυτοματοποιημένη χαρτογράφηση καμένων εκτάσεων με τη χρήση δεδομένων υψηλής ευκρίνειας» στο πλαίσιο του Επιχειρησιακού Προγράμματος «Ανάπτυξη Ανθρώπινου Δυναμικού, Εκπαίδευση και Δια Βίου Μάθηση» που συγχρηματοδοτείται από την Ευρωπαϊκή Ένωση (Ευρωπαϊκό Κοινωνικό Ταμείο) και από εθνικούς πόρους. Η υλοποίηση πραγματοποιήθηκε από την ερευνητική ομάδα του Εργαστηρίου Δασικής Διαχειριστικής και Τηλεπισκόπησης του ΑΠΘ.</p>
                        <img src={espa_banner} alt='ESPA banner'/>
                    </PopupPanel>
                    : null
                }


                <div className={classes.TopbarDesktop}>
                    <div className={classes.TopbarInner}>
                        <div className={classes.SiteNameWrapper}>
                            <Logo/>
                            <h1><i>Χαρτογραφικά Δεδομένα Πυρκαγιών</i></h1>
                        </div>

                        {this.props.loggedIn ? 
                            <div className={classes.LogoutMobile} onClick={() => this.logout()}>
                                <span>Logout</span>
                            </div>

                            :

                            <div className={classes.InfoButtonWrapper}>
                                <div className={classes.BannerWrapper}>
                                    <img src={espa_banner} alt='ESPA banner'/>
                                </div>
                                

                                <Button menuButton={true} clicked={() => this.showInfo()}>
                                    <div>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><path d="M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"></path></svg>
                                        </div>
                                        <span>Πληροφορίες</span>
                                    </div>
                                </Button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = state => {
    return {
        loggedIn: state.loginRegister.loggedIn,
        loggedInUser: state.loginRegister.loggedInUser
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onGetUserFromLocalStorage: () => dispatch(actions.getUserFromLocalStorage()),
        onLogoutUser: () => dispatch(actions.loggedOut()),
        onShowLoginRegister: (type) => dispatch(actions.showLoginRegister(type))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Topbar));